import React from 'react'
import { PropTypes } from 'prop-types';

export class TextArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 

            <textarea value={this.props.value} onChange={this.handleChange} />
         );
    }
}

TextArea.propTypes = {
    value: PropTypes.string
}
export default TextArea;

